class HeaderMobile {
	constructor(item) {
		this.item = item;
		this.hamburger = document.querySelector('.header-mobile__hamburger');
		this.headerNav = document.querySelector('.header-mobile__nav');
		this.activeClass = 'open';
		this.subMenuItems = document.querySelectorAll(
			'.header-mobile__nav .sub-menu',
		);
		this.initEventHandlers();
		this.addToggleButtons();
	}

	addToggleButtons() {
		for (let i = 0, len = this.subMenuItems.length; i < len; i += 1) {
			const item = this.subMenuItems[i];
			let toggleButton = document.createElement('div');
			toggleButton.className = 'header-mobile__toggle';
			toggleButton.innerHTML = '<span></span>';

			toggleButton.addEventListener('click', (e) => {
				this.toggleMenuItem(item.parentElement);
			});

			item.parentElement.appendChild(toggleButton);
		}
	}

	hide(item) {
		item.classList.remove(this.activeClass);
	}

	isActive(item) {
		if (item.classList.contains(this.activeClass)) {
			return true;
		}
	}

	closeOtherItems(currentItem) {
		for (let i = 0, len = this.subMenuItems.length; i < len; i += 1) {
			const item = this.subMenuItems[i].parentElement;
			if (this.isActive(item) && item != currentItem) {
				this.hide(item);
			}
		}
	}

	toggleMenuItem(item) {
		if (this.isActive(item)) {
			this.hide(item);
		} else {
			this.closeOtherItems(item);
			item.classList.add(this.activeClass);
		}
	}

	toggleHeader() {
		this.headerNav.classList.toggle(this.activeClass);
		this.hamburger.classList.toggle(this.activeClass);

		const header = jQuery('.header--mobile');
		jQuery(this.headerNav).css({
			top: header.innerHeight() + header.position().top,
		});
	}

	initEventHandlers() {
		this.hamburger.addEventListener('click', (e) => {
			e.preventDefault();
			this.toggleHeader();
		});
	}
}

document.addEventListener('DOMContentLoaded', function() {
	new HeaderMobile(document.querySelector('.header-mobile'));
});
